export enum FeatureToggleEnum {
    USE_AUTOCOMPLETE_ES_VERSION = 'ft_autocomplete_es_version',
    USE_HOME_PAGE_ES_VERSION = 'ft_home_page_es_version',
    USE_MAP_TILING = 'ft_map_tiling',
    USE_MAP_TILING_V2 = 'ft_map_tiling_v2',
    USE_RANKING_SIMULATOR = 'ft_ranking_simulator',
    USE_LISTING_SSR = 'listing_ssr',
    SM_CONFIRMATION_EMAIL_ID = 'sm_confirmation_email_id',
    SM_CONFIRMATION_EMAIL_ID_HOMEPAGE = 'sm_confirmation_email_id_homepage',
}
